import { Container, Row, Col } from 'reactstrap'

export default function FiveSection() {
    return (
        <section
            className="app-download-section"
            style={{
                backgroundImage: 'url(/images/lp/banner-site-five.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
            }}
        >
            <Container>
                <Row className="align-items-center">
                    <Col xs="12" className="text-white">
                        <div className="app-download-content d-flex align-items-center justify-content-between">
                            <div className="text-content">
                                <h2
                                    className="content-title fw-bold mb-0"
                                >
                                    Baixe agora e seja um<br />
                                    membro da comunidade
                                </h2>
                            </div>

                            <div className="app-download-buttons d-flex flex-row align-items-center gap-3">
                                <a
                                    href="#"
                                    className="download-btn download-btn-ios"
                                    onClick={e => {
                                        e.preventDefault()
                                        window.open(
                                            'https://apps.apple.com/us/app/clube-do-tennis/id6747998672',
                                            '_blank',
                                        )
                                    }}
                                    aria-label="Baixar na App Store"
                                >
                                    <span className="store-icon" aria-hidden>
                                        <img
                                            src="/images/lp/apple-logo-black.png"
                                            alt="App Store"
                                            width={22}
                                            height={22}
                                        />
                                    </span>
                                    <span className="store-lines">
                                        <span className="store-small">Disponível na</span>
                                        <span className="store-name">App Store</span>
                                    </span>
                                </a>
                                <a
                                    href="#"
                                    className="download-btn download-btn-android"
                                    onClick={e => {
                                        e.preventDefault()
                                        window.open(
                                            'https://play.google.com/store/apps/details?id=br.com.clubedotennis.app',
                                            '_blank',
                                        )
                                    }}
                                    aria-label="Baixar no Google Play"
                                >
                                    <span className="store-icon" aria-hidden>
                                        {/* Google Play triangle */}
                                        <img
                                            src="/images/lp/google-play.png"
                                            alt="Google Play"
                                            width={22}
                                            height={22}
                                        />
                                    </span>
                                    <span className="store-lines">
                                        <span className="store-small">Disponível na</span>
                                        <span className="store-name">Google Play</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
